
import divScroll from "@/components/div-scroll/div-scroll.vue";
import {
  Component,
  Vue,
  Prop
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
// import { objAny, objStr, objNumber } from "../../common/common-interface";
@Component({
  components: {
    "pi-div-scroll": divScroll
  }
})
export default class TabsContent extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private tabsList!: object[];
  @Prop({ default: "" }) private tabsActive!: string;
  @Prop({ default: "" }) private type!: string;
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: "" }) private size!: string;
  @Prop({ default: true }) private tabScroll!: boolean;

  public tabsClick(val: string | number): void {
    this.$emit("change", val);
  }

  // mounted() {}
}
